import React from 'react';
import { MessageStructureGalleryElement } from '@mm/state/model/LivechatMessageModel';
import './GalleryElement.pcss';

type Props = {
  element: MessageStructureGalleryElement;
  imageAspectRatio?: 'square' | 'horizontal';
};

export const GalleryElement = ({ element, imageAspectRatio }: Props) => {
  return (
    <div className="lc-gallery-element">
      {element.imageUrl && (
        <img
          className={`lc-gallery-element__image ${imageAspectRatio}`}
          src={element.imageUrl}
        />
      )}
      {element.title && (
        <div className="lc-gallery-element__title">{element.title}</div>
      )}
      {element.subtitle && (
        <div className="lc-gallery-element__subtitle">{element.subtitle}</div>
      )}
      {element.defaultAction && element.defaultAction.type === 'web_url' && (
        <div className="lc-gallery-element__subtitle">
          {element.defaultAction.url}
        </div>
      )}
      {element.buttons &&
        element.buttons.map(btn => {
          const title = btn.type === 'element_share' ? 'Share' : btn.title;

          return (
            <div className="lc-gallery-element__button" key={title}>
              {title}
            </div>
          );
        })}
    </div>
  );
};
